import { render, staticRenderFns } from "./Crawler.vue?vue&type=template&id=2b31a432&"
import script from "./Crawler.vue?vue&type=script&lang=js&"
export * from "./Crawler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports